
import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import { IconButton } from '@mui/material'

import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";

export default function InstructionBanner() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    // function setPage(pageNumber) {}

    const formats = [
        "strike",
        "size",
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'background',
        'list',
        'align',


        'color',
        'indent',
        'clean',
        'blockquote', 'script'

    ];

    const modules = {
        toolbar: [
            ['undo', 'redo'],
            [{ 'size': [] }],
            [{ 'font': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            // ['link'],
            ['clean'],

            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };



    const handleUndo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.undo();
    };

    const handleRedo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.redo();
    };
    const quillRef = React.createRef();

    return (
        <>
            <Card>


                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3> Instruction Banner</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <Box >
                    <div className='mx-4'>
                        <span style={{ color: "#3E4A62" }}>Titile  <span style={{ color: "red" }}>*</span></span>
                        <br />
                        <TextField size='small' sx={{ width: "320px" }} />
                    </div>
                    <div className='mx-4 mt-3 '>
                        <span style={{ color: "#3E4A62" }}>Content  <span style={{ color: "red" }}>*</span></span>
                        <br />
                        {/* <CKEditor
                            editor={ClassicEditor}
                            data={"Google Map"}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            ChangeBody(data);
                            setBody(data)
                        }}
                        /> */}
                        <div>
                            <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                                <UndoIcon />
                            </IconButton>
                            <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                                <RedoIcon />
                            </IconButton>

                            <ReactQuill
                                ref={quillRef}
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                value={"Google Map"}
                            // onChange={setBody}
                            />
                        </div>
                    </div>

                    <div className='mx-4 mt-3 mb-3 text-right'>
                        {HasPermissions(INFO?.InstructionBanner?.actionName, PER?.ScreenPermissions?.Insert) &&
                            <Button variant="contained" sx={{ padding: "15px" }}> Save </Button>
                        }
                    </div>
                    

                </Box >

            </Card>

        </>
    )
}


